import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { Validation } from "Components/TextContext/commonComponentEnums";
import { zipCodeRegex } from "Features/CheckPrice/Products/RiskProducts/riskProductsUtils";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { HouseContentsProductIntroFormValues } from "../houseContentsFormValuesInterfaces";

export const validationSchema =
  (): Yup.ObjectSchema<HouseContentsProductIntroFormValues> => {
    const { getText } = TextManager;
    const postNumberValidationText = getText(Validation.POSTNUMBER);

    return Yup.object({
      addressSameAsHomeAddress: Yup.mixed<BooleanFormType>().required(
        getText("housecontentsform.validation.addresssameashomeaddress"),
      ),
      fullRental: Yup.mixed<BooleanFormType>().when(
        "addressSameAsHomeAddress",
        {
          is: BooleanFormType.FALSE,
          then: (schema) =>
            schema.required(getText("housecontentsform.validation.fullrental")),
        },
      ),
      validPostNumber: Yup.boolean(),
      postNumber: Yup.string().when("addressSameAsHomeAddress", {
        is: BooleanFormType.FALSE,
        then: (schema) =>
          schema
            .required(postNumberValidationText)
            .matches(zipCodeRegex, postNumberValidationText)
            .test("postnumber is valid", postNumberValidationText, function () {
              return this.parent.validPostNumber;
            }),
      }),
      city: Yup.string(),
    }).defined();
  };
